import React from "react";
import { useLocation } from "react-router";
import { Transition } from "react-spring/renderprops";
import { LayoutBackground } from "../index";
import AuthBackground from "./AuthBackground";
import BookingBackground from "./BookingBackground";

export default React.memo(() => {
  const [ immediate, setImmediate ] = React.useState(true);
  React.useEffect(() => {
    setTimeout(() => {
      setImmediate(false);
    }, 0);
  }, [ setImmediate ]);

  const { pathname } = useLocation();

  const items = [
    {
      key: "login",
      visible: pathname?.startsWith?.("/login"),
    },
    {
      key: "booking",
      visible: pathname?.startsWith?.("/booking"),
    },
  ].filter(x => x.visible);

  return (
    <LayoutBackground>
      <Transition
        immediate={immediate}
        items={items}
        keys={item => item.key}
        from={{ opacity: 0 }}
        enter={{ opacity: 1 }}
        leave={{ opacity: 0 }}>
        {({ key }) => {
          switch (key) {
            case "login":
              return (style) => <AuthBackground style={style} />;
            case "booking":
              return (style) => <BookingBackground style={style} />;
            default:
              return null;
          }
        }}
      </Transition>
    </LayoutBackground>
  );
});
